<template>
  <div class="cs-deposit">
    <div class="orb orb-gold"></div>
    <div class="orb orb-warm"></div>

    <div class="wrap">
      <section class="hero">
        <div class="online-pill">
          <span class="pulse-dot"></span>
          {{ $t('CS Deposit Online') }}
        </div>
        <div class="logo-ring">
          <img :src="siteLogo" :alt="siteTitle" class="site-logo">
        </div>
        <div class="vip-chip">{{ $t('CS Deposit Exclusive') }}</div>
        <h1 class="headline">{{ $t('CS Deposit Headline') }}</h1>
        <p class="sub">{{ $t('CS Deposit Sub') }}</p>
        <div v-if="rechargeBonus > 0" class="gift-banner">
          {{ $t('CS Deposit Gift', { n: rechargeBonus }) }}
        </div>
      </section>

      <section class="stats">
        <div class="stat">
          <strong>24H</strong>
          <span>{{ $t('CS Deposit Fast') }}</span>
        </div>
        <div class="stat-line"></div>
        <div class="stat">
          <strong>1V1</strong>
          <span>{{ $t('CS Deposit Safe') }}</span>
        </div>
        <div class="stat-line"></div>
        <div class="stat">
          <strong>VIP</strong>
          <span>{{ $t('CS Deposit Exclusive') }}</span>
        </div>
      </section>

      <section class="amount-card">
        <div class="amount-head">
          <span>{{ $t('CS Deposit Amount Hint') }}</span>
          <em v-if="amount">¥{{ formatAmount(amount) }}</em>
        </div>
        <div class="chips">
          <button
            v-for="item in amounts"
            :key="item"
            type="button"
            :class="['chip', { active: amount === item }]"
            @click="selectAmount(item)"
          >{{ formatAmount(item) }}</button>
        </div>
      </section>

      <button type="button" class="cta" @click="contactKefu">
        <span class="cta-shine"></span>
        <span class="cta-icon">
          <svg viewBox="0 0 24 24" width="22" height="22" fill="none">
            <path d="M4 12a8 8 0 0 1 8-8h1v3l4-4-4-4v3h-1A11 11 0 0 0 3 12c0 2.1.6 4.1 1.7 5.8L3 21l3.4-1.1A10.9 10.9 0 0 0 12 23a11 11 0 0 0 11-11h-3a8 8 0 0 1-16 0z" fill="currentColor"/>
          </svg>
        </span>
        <span class="cta-text">{{ $t('CS Deposit CTA') }}</span>
      </button>

      <section class="steps">
        <div class="step">
          <span class="num">1</span>
          <p>{{ $t('CS Deposit Step1') }}</p>
        </div>
        <div class="step-arrow">›</div>
        <div class="step">
          <span class="num">2</span>
          <p>{{ $t('CS Deposit Step2') }}</p>
        </div>
        <div class="step-arrow">›</div>
        <div class="step">
          <span class="num">3</span>
          <p>{{ $t('CS Deposit Step3') }}</p>
        </div>
      </section>

      <p class="guarantee">{{ $t('CS Deposit Guarantee') }}</p>
    </div>
  </div>
</template>

<script>
import { isKefuRechargePage } from '@/utils/deposit';

export default {
  name: 'rechargeKefu',
  data() {
    return {
      amount: 1000,
      amounts: [100, 200, 500, 1000, 2000, 5000, 10000, 30000],
    };
  },
  computed: {
    siteLogo() {
      return (this.$store.state.appInfo && this.$store.state.appInfo.site_logo) || '/static/image/woa-logo.svg';
    },
    siteTitle() {
      return (this.$store.state.appInfo && this.$store.state.appInfo.title) || '';
    },
    rechargeBonus() {
      const n = Number(this.$store.state.appInfo && this.$store.state.appInfo.recharge_fee);
      if (!Number.isFinite(n) || n <= 0) return 0;
      return Number.isInteger(n) ? n : Number(n.toFixed(2));
    },
  },
  created() {
    this.ensureMode();
  },
  watch: {
    '$store.state.appInfo.recharge_kefu_page'() {
      this.ensureMode();
    },
  },
  methods: {
    ensureMode() {
      if (!isKefuRechargePage(this.$store.state.appInfo)) {
        this.$router.replace('/recharge').catch(() => {});
      }
    },
    formatAmount(val) {
      return Number(val).toLocaleString('en-US');
    },
    selectAmount(val) {
      this.amount = val;
    },
    copyAmount() {
      if (!this.amount) return;
      try {
        const input = document.createElement('input');
        input.style.opacity = '0';
        input.value = String(this.amount);
        document.body.appendChild(input);
        input.select();
        document.execCommand('copy');
        document.body.removeChild(input);
      } catch (e) { /* ignore */ }
    },
    contactKefu() {
      this.copyAmount();
      if (this.$parent && typeof this.$parent.showTost === 'function') {
        this.$parent.showTost(1, this.$t('CS Deposit Copied'));
      }
      if (this.$parent && typeof this.$parent.goNav === 'function') {
        this.$parent.goNav('/kefu');
        return;
      }
      this.$router.push('/kefu').catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.cs-deposit {
  position: relative;
  min-height: 100vh;
  overflow: hidden;
  padding: 72px 16px 96px;
  box-sizing: border-box;
  background:
    radial-gradient(120% 80% at 50% -10%, #fff6e4 0%, #ffffff 42%, #f7efe4 100%);
  color: #3d2a16;
}

.orb {
  position: absolute;
  border-radius: 50%;
  pointer-events: none;
  filter: blur(8px);
}
.orb-gold {
  width: 240px;
  height: 240px;
  top: -70px;
  right: -80px;
  background: radial-gradient(circle, rgba(255, 214, 120, 0.55), rgba(255, 214, 120, 0));
}
.orb-warm {
  width: 200px;
  height: 200px;
  left: -90px;
  top: 180px;
  background: radial-gradient(circle, rgba(184, 120, 48, 0.18), rgba(184, 120, 48, 0));
}

.wrap {
  position: relative;
  z-index: 1;
  max-width: 420px;
  margin: 0 auto;
}

.hero {
  text-align: center;
  padding: 18px 8px 8px;
}

.online-pill {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.78);
  border: 1px solid #ead1b2;
  color: #2f9d4e;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.4px;
}

.pulse-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #22c55e;
  box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.6);
  animation: pulse 1.6s infinite;
}

.logo-ring {
  width: 86px;
  height: 86px;
  margin: 18px auto 12px;
  border-radius: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(180deg, #fffdf8, #fff3dc);
  border: 1px solid #f0d7aa;
  box-shadow: 0 10px 28px rgba(176, 118, 32, 0.18);
}

.site-logo {
  max-width: 68px;
  max-height: 42px;
  object-fit: contain;
}

.vip-chip {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 1px;
  color: #6a4308;
  background: linear-gradient(135deg, #ffe082, #d1a03e);
  box-shadow: 0 4px 12px rgba(209, 160, 62, 0.28);
}

.headline {
  margin: 14px 0 8px;
  font-size: 24px;
  line-height: 1.35;
  font-weight: 800;
  color: #3a2714;
}

.sub {
  margin: 0;
  font-size: 13px;
  color: #8a6a4a;
  letter-spacing: 0.8px;
}

.gift-banner {
  margin: 14px auto 0;
  display: inline-flex;
  padding: 7px 14px;
  border-radius: 10px;
  background: linear-gradient(90deg, #ff6b6b, #ee5a6f);
  color: #fff;
  font-size: 13px;
  font-weight: 800;
  box-shadow: 0 8px 18px rgba(238, 90, 111, 0.28);
}

.stats {
  margin-top: 22px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 10px;
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.86);
  border: 1px solid #eadfd3;
  box-shadow: 0 8px 22px rgba(117, 73, 34, 0.08);
}

.stat {
  flex: 1;
  text-align: center;
  strong {
    display: block;
    font-size: 16px;
    color: #8f501f;
    letter-spacing: 0.5px;
  }
  span {
    display: block;
    margin-top: 4px;
    font-size: 11px;
    color: #8a6a4a;
  }
}

.stat-line {
  width: 1px;
  height: 28px;
  background: #ead1b2;
}

.amount-card {
  margin-top: 16px;
  padding: 16px;
  border-radius: 18px;
  background: #ffffff;
  border: 1px solid #eadfd3;
  box-shadow: 0 8px 22px rgba(117, 73, 34, 0.08);
}

.amount-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
  font-size: 13px;
  color: #5c3a12;
  font-weight: 700;
  em {
    font-style: normal;
    color: #b8860b;
    font-size: 16px;
  }
}

.chips {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
}

.chip {
  height: 38px;
  border: 1px solid #ead1b2;
  border-radius: 10px;
  background: #fff8ef;
  color: #5c3a12;
  font-size: 13px;
  font-weight: 700;
  &.active {
    background: linear-gradient(180deg, #fff3cc, #f0c56b);
    border-color: #d1a03e;
    color: #6a4308;
    box-shadow: 0 4px 12px rgba(209, 160, 62, 0.22);
  }
}

.cta {
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 56px;
  margin-top: 20px;
  border: 0;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #4a2e00;
  font-size: 17px;
  font-weight: 800;
  letter-spacing: 1px;
  background: linear-gradient(135deg, #ffe082 0%, #d1a03e 52%, #b8860b 100%);
  box-shadow: 0 10px 24px rgba(209, 160, 62, 0.38), 0 0 0 6px rgba(209, 160, 62, 0.12);
  animation: cta-breath 2.4s ease-in-out infinite;
  &:active {
    transform: translateY(1px);
  }
}

.cta-icon {
  display: flex;
  position: relative;
  z-index: 1;
}

.cta-text {
  position: relative;
  z-index: 1;
}

.cta-shine {
  position: absolute;
  top: 0;
  left: -60%;
  width: 46%;
  height: 100%;
  background: linear-gradient(to right, transparent, rgba(255,255,255,0.5), transparent);
  transform: skewX(-24deg);
  animation: sweep 2.8s infinite;
}

.steps {
  margin-top: 22px;
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  padding: 14px 8px;
}

.step {
  flex: 1;
  text-align: center;
  .num {
    display: inline-flex;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #ffe082, #d1a03e);
    color: #5c3a00;
    font-size: 12px;
    font-weight: 800;
  }
  p {
    margin: 8px 0 0;
    font-size: 11px;
    line-height: 1.4;
    color: #8a6a4a;
  }
}

.step-arrow {
  width: 16px;
  padding-top: 2px;
  color: #d1a03e;
  font-size: 18px;
  font-weight: 700;
}

.guarantee {
  margin: 4px 8px 0;
  text-align: center;
  font-size: 12px;
  color: #a08060;
  line-height: 1.5;
}

@keyframes pulse {
  0% { box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.55); }
  70% { box-shadow: 0 0 0 8px rgba(34, 197, 94, 0); }
  100% { box-shadow: 0 0 0 0 rgba(34, 197, 94, 0); }
}

@keyframes sweep {
  0% { left: -60%; }
  35% { left: 120%; }
  100% { left: 120%; }
}

@keyframes cta-breath {
  0%, 100% { box-shadow: 0 10px 24px rgba(209, 160, 62, 0.38), 0 0 0 6px rgba(209, 160, 62, 0.1); }
  50% { box-shadow: 0 12px 28px rgba(209, 160, 62, 0.48), 0 0 0 10px rgba(209, 160, 62, 0.16); }
}
</style>



// WEBPACK FOOTER //
// src/components/rechargeKefu.vue